import { HolidayGiftIcon, PatrioticGiftIcon, ReferralIcon } from 'assets/icons';
import IconButton from 'components/foundation/buttons/IconButton/IconButton';
import { DateTime } from 'luxon';
import './ReferralButton.scss';

export interface IReferralButtonProps {
  onClick: () => void;
}

const ReferralButton = ({ onClick }: IReferralButtonProps) => {
  function getIcon() {
    const month = DateTime.now().month;
    if (month === 12) {
      return { svg: HolidayGiftIcon, className: 'holiday-icon' };
    }
    if (month === 7) {
      return { svg: PatrioticGiftIcon, className: 'patriotic-icon' };
    }
    return { svg: ReferralIcon, className: undefined };
  }

  const icon = getIcon();

  return (
    <div className="referral-button-icon">
      <IconButton svg={icon.svg} className={icon.className} onClick={onClick} />
    </div>
  );
};

export default ReferralButton;
